import React from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Slide,
  Grid,
  TextField,
  Alert,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  FormGroup,
  FormControlLabel,
  Switch,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { EventContext } from "../../../contexts/EventContext";
// import ProfileTextField from "./components/ProfileTextField";
// import ProfileSelectField from "./components/ProfileSelectField";

import request from "../../../utilities/requests";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const EditAdminUserDialog = ({ open, close, user }) => {
  const { userData } = React.useContext(EventContext)
  const [username, setUsername] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [error, setError] = React.useState(null);
  const [showConfirm, setShowConfirm] = React.useState(false);
  const [canViewPermissions, setCanViewPermissions] = React.useState(false);
  const [permissions, setPermissions] = React.useState(null);

  React.useEffect(() => {
    if (user) {
      setUsername(user.username);
      setEmail(user.email);
      setPhone(user.phone);
      setFirstName(user?.profile?.firstName);
      setLastName(user?.profile?.lastName);
      if (userData?.role === 'superadmin' || userData?.permissions?.canManageAdminUsers) {
        setCanViewPermissions(true);
        getPermissions();
      }
    }
  }, [user]);

  const getPermissions = async () => {
    const result = await request(`users/permissions?userId=${user._id}`);
    if (result.success) {
      setPermissions(result.permissions);
    }
  };

  const convertLabel = (field) => {
    const result = field.replace(/([A-Z])/g, " $1");
    const finalResult = result.charAt(0).toUpperCase() + result.slice(1);
    return finalResult;
  };

  const renderPermissions = () => {
    if (!permissions) {
      return <></>;
    }

    return (
      <Grid item>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="button">Permissions</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <FormGroup>
              {Object.keys(permissions).map((field) => {
                let fieldName = convertLabel(field);
                return (
                  <FormControlLabel
                    key={fieldName}
                    control={
                      <Switch
                        checked={permissions[field]}
                        onChange={() => handleSwitch(field)}
                      />
                    }
                    label={fieldName}
                  />
                );
              })}
            </FormGroup>
          </AccordionDetails>
        </Accordion>
      </Grid>
    );
  };

  const handleSwitch = async (field) => {
    permissions[field] = !permissions[field];
    setPermissions({ ...permissions });
    const body = {
      userId: user._id,
      field: field,
      value: permissions[field],
    };
    const result = await request("users/permissions", "post", body);
    if (!result.success) {
      permissions[field] = !permissions[field];
      setPermissions({ ...permissions });
    }
  };

  const handleSave = async () => {
    let error;
    if (!username) {
      error = "Please enter a username";
    } else if (!email) {
      error = "Please enter an email";
    } else if (!phone) {
      error = "Please enter a phone number";
    } else if (!firstName) {
      error = "Please enter a first name";
    } else if (!lastName) {
      error = "Please enter a last name";
    }
    if (error) {
      setError(error);
      return;
    } else {
      setError(null);
    }

    const body = {
      userId: user._id,
      phone,
      firstName,
      lastName,
    };

    const result = await request("profile/adminupdate", "post", body);
    if (!result.success) {
      setError(result.error);
      return;
    }
    close();
  };

  const handleDelete = async () => {
    const body = {
      userId: user._id,
      admin: true,
    };

    const result = await request("users/delete", "post", body);
    if (!result.success) {
      return;
    }
    setShowConfirm(false);
    close();
  };

  return (
    <div>
      <Dialog
        fullScreen
        open={open}
        onClose={close}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={close}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Edit Profile
            </Typography>
            <Button autoFocus color="inherit" onClick={handleSave}>
              save
            </Button>
          </Toolbar>
        </AppBar>
        <Grid container direction="column" spacing={3} style={{ padding: 20 }}>
          {error ? (
            <Grid item>
              <Alert severity="error">{error}</Alert>
            </Grid>
          ) : (
            <></>
          )}

          <Grid item>
            <TextField fullWidth label="username" value={username} disabled />
          </Grid>
          <Grid item>
            <TextField fullWidth label="email" value={email} disabled />
          </Grid>
          <Grid item>
            <TextField
              fullWidth
              label="phone*"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </Grid>
          <Grid item>
            <TextField
              fullWidth
              label="first name*"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
          </Grid>
          <Grid item>
            <TextField
              fullWidth
              label="last name*"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
          </Grid>
          {canViewPermissions ? renderPermissions() : <></>}

          <Grid item>
            <Button
              variant="outlined"
              onClick={handleSave}
              style={{ width: "100%" }}
            >
              Save
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="outlined"
              onClick={() => setShowConfirm(true)}
              style={{ width: "100%" }}
              color="secondary"
            >
              Delete
            </Button>
          </Grid>
        </Grid>
      </Dialog>
      <Dialog open={showConfirm} onClose={() => setShowConfirm(false)}>
        <DialogTitle id="alert-dialog-title">{"Confirm Delete"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete {user?.profile?.firstName}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowConfirm(false)}>Cancel</Button>
          <Button onClick={handleDelete} autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default EditAdminUserDialog;
